import axios from 'axios';
import store from 'store';

const state = {
  mover: [],
  movers: {},
  step: 'movers-info',
  paginatedMovers: {},
};

const getters = {
  getMoversFiltered: st => {
    return query => {
      axios.get(`movers?${query}`).then(res => {
        st.paginatedMovers = res.data;
      });
    };
  },
};

const mutations = {
  setMover: (st, payload) => {
    st.mover = payload;
  },
  setMovers: (st, payload) => {
    st.movers = payload;
  },
  setMoversStep: (st, payload) => {
    st.step = payload;
  },
  setPaginatedMovers: (st, payload) => {
    st.paginatedMovers = payload;
  },
};

const actions = {
  getMovers: ({ commit }) => {
    return new Promise(resolve => {
      if (store.get('permissions').indexOf('carriers.movers.index') >= 0) {
        axios
          .get(`movers?paginated=false`)
          .then(res => {
            commit('setMovers', res.data);
            resolve();
          })
          .catch();
      }
    });
  },
  getPaginatedMovers: ({ commit }) => {
    commit('setPaginatedMovers', {});
    if (store.get('permissions').indexOf('carriers.movers.index') >= 0) {
      axios.get(`movers`).then(res => {
        commit('setPaginatedMovers', res.data);
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/movers.js